import { createStore } from 'vuex';

export default createStore({
    state: {
        dictionary: {},
    },
    mutations: {
        setDictionary(state, dictionary) {
            state.dictionary = dictionary;
        },
    },
    getters: {
        getText: (state) => (key) => {
            return state.dictionary[key] || key;
        },
    },
});
